import PropTypes from 'prop-types'

import GalleryTag, {GALLERY_TAG_TYPES} from './GalleryTag.js'

// The counter tag plus an optional video tag.
const GalleryControls = ({
  className,
  counterLabel,
  counterType,
  hasVideo,
  isVideoIconOnly,
  negative,
  onCounterClick,
  onVideoClick,
  videoLabel,
  ...props
}) => (
  <div className={className} {...props}>
    <GalleryTag
      type={counterType}
      onClick={onCounterClick}
      clickable={!!onCounterClick}
      negative={negative}
      className={`${className}-counter`}
    >
      {counterLabel}
    </GalleryTag>
    {hasVideo && (
      <GalleryTag
        type={GALLERY_TAG_TYPES.VIDEO}
        aria-label={isVideoIconOnly ? videoLabel : undefined}
        onClick={onVideoClick}
        clickable={!!onVideoClick}
      >
        {isVideoIconOnly ? undefined : videoLabel}
      </GalleryTag>
    )}
  </div>
)

GalleryControls.displayName = 'GalleryControls'

GalleryControls.propTypes = {
  className: PropTypes.string.isRequired,
  counterLabel: PropTypes.node.isRequired,
  counterType: PropTypes.oneOf(Object.values(GALLERY_TAG_TYPES)),
  hasVideo: PropTypes.bool,
  isVideoIconOnly: PropTypes.bool,
  negative: PropTypes.bool,
  onCounterClick: PropTypes.func,
  onVideoClick: PropTypes.func,
  videoLabel: PropTypes.string
}

export default GalleryControls
